export default {
  apiBaseUrl: 'https://mac-api.hausmart.com',
  apiBaseUrlRambla: 'https://rambla.hausmart.com',
  avedaWebApp: 'https://shop.aveda.com',
  ramblaFrontendBaseUrl: 'https://ramblas.io',
  shopifyAppHandle: 'rambla-sync',
  customDomainCnameTarget: 'customers.ramb.la',
  featureFlags: {
    quicksight: true,
    ownerGroup: true,
    offerCodes: false,
    templateLooks: false,
    landingPage: false,
    embeddableWidgets: false,
  },
};
